module.exports = __webpack_public_path__ + "img/truck-menu-grupo-formulario.c3e111e4.png";